










import { MountingPortal } from 'portal-vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    MountingPortal
  }
})
export default class Modal extends Vue {
  mounted () {
    document.body.classList.add('modal-open')
  }

  destroyed () {
    document.body.classList.remove('modal-open')
  }
}
